{
  "Login": "Connexion",
  "Local Login": "Connexion Locale",
  "email": "email",
  "password": "mot de passe"
}
